/** 
 * @file        encodeDataURI.js
 * @author      Nazila Akhavan <nazila@kingsds.network>
 * @date        Sep 2020
 * 
 * Encode input and return the URI.
 */
'use strict';

const kvin = require('kvin');
const DCP_ENV = require('dcp/common/dcp-env');
const { btoa } = require('./content-encoding');
/**
 * Encode input to data:[<MIME-type>][;base64][;charset=<encoding>],<data>
 * @param { string | object } input 
 * @param { string } [MIMEType] 
 */
exports.encodeDataURI = function utils$$encodeDataURI (input, MIMEType) {
  let inputType = typeof input;
  if (inputType === 'string' && input.startsWith('data:')) /* Already encoded, avoid double encoding */
    return input;
  let temp, encoding;
  let textType, imageType;
  if(MIMEType) {
    temp = MIMEType.split(';');
    MIMEType = temp[0];
    if(temp[1]) encoding = temp[1];
    textType = MIMEType.match(/text\/.*/);
    textType = textType?  textType[0] : [];
    imageType = MIMEType.match(/image\/.*/);
    imageType = imageType? imageType[0] : [];
  } else {
    switch (inputType) {
      case 'string':
        MIMEType = 'text/plain';
        break;

      case 'boolean':
        MIMEType = 'application/json';
        break;

      default:
        MIMEType = 'application/x-kvin';
        break;
    }
  }

  switch (MIMEType) {
    case 'application/javascript':  
    case 'text/plain':
      if(encoding === 'base64') {
        return 'data:text/plain;base64,' + btoa(input);
      }
      return 'data:,' + encodeURI(input);

    case 'application/json':
      return 'data:application/json,' + (typeof input === 'string' ? encodeURI(input) : encodeURI(JSON.stringify(input)));

    case 'application/x-kvin':
      return 'data:application/x-kvin,' + (typeof input === 'string' ? encodeURI(input) : encodeURI(kvin.serialize(input)));

    case 'application/octet-stream':
      input = new Uint8Array(input);
      return 'data:application/octet-stream;base64,' + btoa(input);   

    case textType:
      return `data:${textType},` + encodeURI(input);

    case imageType:
      if (inputType === 'string') return `data:${imageType};base64,` + btoa(input);
      input = new Uint8Array(input.buffer)
      return encodeURI(`data:${imageType};base64,` + btoa(input)); 

    default:
      throw new Error(`The content type ${MIMEType} is not supported in encodeDataURI()!`)
  }
}

// https://stackoverflow.com/questions/11089732/display-image-from-blob-using-javascript-and-websockets
// public method for encoding an Uint8Array to base64

function encode(input) {
  var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  var output = "";
  var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
  var i = 0;

  while (i < input.length) {
      chr1 = input[i++];
      chr2 = i < input.length ? input[i++] : Number.NaN; // Not sure if the index 
      chr3 = i < input.length ? input[i++] : Number.NaN; // checks are needed here

      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
          enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
          enc4 = 64;
      }
      output += keyStr.charAt(enc1) + keyStr.charAt(enc2) +
                keyStr.charAt(enc3) + keyStr.charAt(enc4);
  }
  return output;
}

 
 
